module.exports = __webpack_public_path__ + "static/media/planet.3ac6c771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameSpacePort/planet.png
// module id = 2476
// module chunks = 0